export enum RoutePath {
    FAQPAGE = 'business-opportunity-faq',
    WHYFOREVER = 'whyforever',
    YOUROPPORTUNITY = 'your-opportunity',
    WHAT_IT_TAKES_TO_BE_A_FBO = 'what-it-takes-fbo',
    WELCOME = 'welcome',
    FBOFAQ = 'fbo-faq',
    ForeverLivingFAQ = 'forever-living-faq',
    IDCARD = 'tools',
    SALESLINK = 'sales-link',
    TOOLS = 'business-tools',
    RECOGNITION = 'recognition',
    ABOUT = 'about',
    FROM_PLANT_TO_PRODUCT_TO_YOU = 'plant-product-you'
}
